export var EResultType;
(function (EResultType) {
    EResultType["LineChart"] = "LineChart";
    EResultType["ComplexTable"] = "ComplexTable";
    EResultType["Coker"] = "Coker";
})(EResultType || (EResultType = {}));
//# sourceMappingURL=result.enum.js.map